export default (el, threshold, callback) => {
  if (!el) {
    return
  }

  const elPos = el.getBoundingClientRect().y || el.getBoundingClientRect().top

  if (elPos <= threshold && callback) {
    callback.apply(null)
  }
}



// WEBPACK FOOTER //
// ./src/utils/lazy-load.js